<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .share-resume-header {
    @include mixins.h2();
  }

  .modal-content {
    display: flex;
    gap: utils.in_rem(16px);
    padding: utils.in_rem(16px);
    background: colors.get(interfaceSwGrey_5);
    height: 100%;
  }
</style>

<script>
  import Modal from "@sourcewhale/shared/svelte-design-system/components/molecules/Modal/Modal.svelte";
  import { activePopUpModalStore } from "../../stores";
  import { createShareResumeContext } from "./context.svelte";
  import Preview from "./Preview.svelte";
  import Settings from "./Settings/Settings.svelte";

  createShareResumeContext();

  const closeModal = () => {
    activePopUpModalStore.set(null);
  };
</script>

<Modal
  onclose={closeModal}
  blur={true}
  modalContentsStyle="width: calc(min(90vw, 1080px)); height: calc(min(90vh, 924px))"
  headerStyle="padding: 0.5rem 1.5rem;"
>
  <span class="share-resume-header" slot="header">Share resume</span>
  <div class="modal-content">
    <Preview />
    <Settings />
  </div>
</Modal>
